import { sva } from "@agapi/ui/panda/css";

export const navbarMegamenuStyles = sva({
  slots: ['megaMenuColumn', 'megaMenuHeaderTitle', 'megaMenuLink', 'megaMenuMoreButton'],
  base: {
    megaMenuColumn: {
      gap: '0',
      pb: '4'
    },
    megaMenuHeaderTitle: {},
    megaMenuLink: {},
    megaMenuMoreButton: {
      justifyContent: 'flex-start'
    }
  }
});
